









































































































import { Component, Prop, Vue} from 'vue-property-decorator';
import OnBoarding from '../../apiClient/OnBoarding';
import _ from 'underscore';
import Alert from '@/components/generics/Alert.vue';
import VueElementLoading from 'vue-element-loading';
import bus from "../../bus";
import GoBackButton from '@/components/generics/GoBackButton.vue';


@Component({
  components: {
    Alert,
    VueElementLoading,
    GoBackButton
  }
})

export default class ListOnBoarding extends Vue {
  ob : OnBoarding;
  show : boolean;
  list : any;
  $refs: {
    alert: HTMLElement
  }
  data () {
    return {
      list:[],
      message : '',
      show : false
    }
  }
  created() {
    this.ob = new OnBoarding();
    this.getListTemplate();

    bus.$on("userchange", () => {
      this.list = [];
    });
  }
  getListTemplate(){
    this.ob.getListTemplate()
        .then((result:any) => {
          if (result.status == 200){
            this.list = result.data;
          }
          this.show = true;
        })
        .catch((error:any) => {
          this.show = true;
          if(error.response.status != '404'){
            var ComponentClass = Vue.extend(Alert);
            var instance = new ComponentClass({propsData: { role: 'danger', title: 'Error', message: this.$t('message.error_'+error.response.data.code) }}).$mount();
            this.$refs.alert.appendChild(instance.$el);
          }
        })
  }
  edit(value:any){
    if (value.activo =='true'){
      this.$router.push({ name: "obedit", params: { id: value.id }});
    }
  }
  disabled(item:any, activo: number){
    let that = this;
    var ComponentClass = Vue.extend(Alert);
    this.ob.disabledTemplate(item.id, activo)
        .then((result:any) => {
          if(result.status == 200 && activo == 1) {
            var instance = new ComponentClass({propsData: { role: 'success', title: that.$t('message.msj_success_title_list'), message: this.$t('message.msj_success_list') }}).$mount();
            this.$refs.alert.appendChild(instance.$el);
            this.list.forEach(element => {
              if(element.id == item.id){
                element.activo ="true";
              }
            });
          }else{
            var instance = new ComponentClass({propsData: { role: 'danger', title: that.$t('message.msj_warning_title_list'), message: this.$t('message.msj_warning_list') }}).$mount();
            this.$refs.alert.appendChild(instance.$el);
            this.list.forEach(element => {
              if(element.id == item.id){
                element.activo ="false";
              }
            });
          }
        })
        .catch((error:any) => {
          var instance = new ComponentClass({propsData: { role: 'danger', title: 'Error', message: that.$t('message.error_'+error.response.data.code) }}).$mount();
          this.$refs.alert.appendChild(instance.$el);
        })
  }
}
